module.exports = __webpack_public_path__ + "img/pre-university-guide.3861e675.png";